import type { SupportTicketStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/support-ticket";

/**
 * Human-readable labels for support ticket statuses.
 */
export const SupportTicketStatusReadable: Record<SupportTicketStatus, string> =
  {
    OPEN: "Open",
    CLOSED: "Closed",
    SNOOZED: "Snoozed",
    IN_PROGRESS: "In Progress",
    HIDDEN: "Hidden",
    ARCHIVED: "Archived",
    DELETED: "Deleted",
    DRAFT: "Draft",
  };
